import React, { useEffect, useState } from 'react'
import Wrapper from '../../Wrapper'
import { HeaderButton, Toolbar } from '../../../../ui/molecules/Layout'
import { Linking, StyleSheet, Text, View } from 'react-native'
import Loading from '../../../../screens/Loading'
import {
  ArrowDownIcon,
  BackHeader,
  NewAttchmentIcon,
} from '../../../../assets/icons'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import { isWeb } from '../../../../utils/helpers/commonUtils'
import { routes } from '@linqpal/models'
import { useTranslation } from 'react-i18next'
import { ProjectSelectionBottomModal } from '../../../../ui/organisms/ProjectSelectionBottomModal'
import { useInvoiceDetailsContext } from '../../TabInvoice/InvoiceDetailsContext'
import { paths } from '../../../links'
import ReceiptStore from './ReceiptStore'
import { observer } from 'mobx-react-lite'
import { PaymentDetails } from './PaymentDetails'
import { DetailsRowItem } from '../PayInvoice/DetailsRowItem'

interface InvoiceReceiptProps {
  route: any
  navigation: any
}

const ProjectName = ({ name }) => {
  return (
    <View style={styles.projectNameView}>
      <Text style={styles.projectName}>{name}</Text>
      <ArrowDownIcon />
    </View>
  )
}

export const ToolbarCenter = () => {
  const { t } = useTranslation('global')
  return (
    <Text style={styles.toolbarHeading}>
      {t('InvoiceReceipt.payment_details')}{' '}
    </Text>
  )
}

export const ToolbarRight = ({ invoice }) => {
  const [url, setUrl] = useState(undefined)
  useEffect(() => {
    if (invoice?.invoice_document) {
      routes.file
        .download(invoice.invoice_document)
        .then(({ url: u }) => setUrl(u))
    }
  }, [invoice])
  return invoice?.invoice_document ? (
    <GetIcon
      icon={<NewAttchmentIcon height="20" width="20" />}
      onPress={() => {
        if (isWeb) {
          window.open(url, '_blank')
        } else {
          Linking.openURL(url || '')
        }
      }}
    />
  ) : (
    <View style={{ width: 20 }} />
  )
}

export const ToolbarLeft = ({ navigation }) => {
  const onBackPress = () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.navigate(paths.Console.Payables._self, {
        screen: paths.Console.Payables.home,
      })
    }
  }

  return (
    <HeaderButton
      icon={
        <GetIcon
          icon={<BackHeader height="20" width="20" />}
          onPress={onBackPress}
        />
      }
    />
  )
}

export const InvoiceReceipt: React.FC<InvoiceReceiptProps> = observer(
  ({ route, navigation }) => {
    const { t } = useTranslation('global')
    const { id } = route.params
    const { getInvoice, loading, invoice } = ReceiptStore
    const { setProjectSelectionModalVisibility } = useInvoiceDetailsContext()

    useEffect(() => {
      getInvoice(id)
    }, [id, getInvoice])

    const showProjectSelection = () => {
      setProjectSelectionModalVisibility(true)
    }

    if (!invoice || loading) {
      return <Loading />
    }

    return (
      <Wrapper
        toolbar={
          <Toolbar
            centerComponent={<ToolbarCenter />}
            leftComponent={<ToolbarLeft navigation={navigation} />}
            rightComponent={<ToolbarRight invoice={invoice} />}
            containerStyle={{ width: 440 }}
          />
        }
      >
        <PaymentDetails />
        {invoice?.project ? (
          <DetailsRowItem
            leftText={`${t('InvoiceReceipt.project')}`}
            rightText={<ProjectName name={invoice?.project.name} />}
            onPress={showProjectSelection}
          />
        ) : (
          <DetailsRowItem
            leftText={`${t('InvoiceReceipt.project')}`}
            rightText={
              <Text
                style={{ color: commonColors.accentText }}
                onPress={showProjectSelection}
              >
                {t('InvoiceReceipt.add_to_project')}
              </Text>
            }
          />
        )}
        <ProjectSelectionBottomModal invoice={invoice} />
      </Wrapper>
    )
  },
)

const styles = StyleSheet.create({
  projectNameView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  projectName: {
    color: commonColors.accentText,
    marginRight: 4,
  },
  toolbarHeading: {
    fontSize: 16,
    fontWeight: '500',
  },
})
